import React from 'react';

/** Telegram's round blue mark with the white plane, as the sign-in boards draw it. */
export function TelegramLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className={className}>
      <circle cx="12" cy="12" r="11" fill="#229ED9" />
      <path
        d="M5.6 11.7 16.8 7.4c.5-.2 1 .1.8.9l-1.9 9c-.1.6-.5.8-1.1.5l-2.9-2.2-1.4 1.4c-.2.2-.3.3-.6.3l.2-3 5.4-4.9c.2-.2 0-.3-.4-.1l-6.7 4.2-2.9-.9c-.6-.2-.6-.6.2-.9Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export default TelegramLogo;
